/**
 * @module root/web
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable:no-any */ // We need to be able to allow developers send any payload the want
// It is not considering import as declaration , throwing lint error at import statement itself
import { CommonUtilService } from './../../support/shared/services/common-util.service';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { Component, ViewEncapsulation, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiGatewayService, HttpEventInterceptorService } from '@core/public';
import { NavbarService } from '../shared/services/navbar.service';
import { GlobalErrorModalComponent } from '../shared/components/global-error-modal/global-error-modal.component';
import { GlobalMessages } from '@core/aem/interfaces/global-messages/global-messages.interface';
import { GlobalErrorModalInterface } from '../shared/interfaces/global-error-modal.interface';
import { GLOBAL_ERROR_MODAL_CONSTANTS } from '../shared/constants/global-error-modal.constants';
import { NavigationEnd, Router } from '@angular/router';
import { APIError } from '@support/api/common/error.interface';
import { CartLine, MaxLinesData } from '@support/api/proxies/responses/api-cart-response.interface';
import { SHARED_CONSTANTS } from '@root/shared/constants/shared-constants.constants';
import { CustomerProfileService } from '@support/customer-login/services/customer-profile.service';
import { AnonymousTokenResponse } from '@support/api/proxies/responses/api-999.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import { Subject } from 'rxjs';
import { WEB_COMPONENT_CONSTANTS } from '@root/web/web.component.constants';
import { FooterModuleEnhancements, Footer } from '@root/shared/models/footer.interface';
import {
  HeaderPrimaryNav,
  ModuleEnhanceMentsNavbar,
} from '@root/shared/models/header-primary-nav.interface';
import { Content } from '@core/aem/models/content.interface';
import { AppConfig } from '@root/app.config';

// Services
import { Wove } from 'aspect.js/';
import { ContentProviderService } from '@core/aem/services/content-provider.service';
import { Workflow } from '@root/shared/interfaces/workflow.interface';
import { WorkflowService } from '@root/shared/services/workflow.service';
import { MarketingService } from '@root/shared/services/marketing.service';
import { MarketingDataEmitterInterface } from '@root/shared/interfaces/marketing.interface';
import { GLOBAL_ERROR_EXCEPTION_CODE } from '@root/shared/constants/global-error-modal.constants';
import { ERROR_MESSAGES } from '@root/shared/components/global-error-modal/global-error-modal.constants';
import { GlobalErrorService } from '@support/shared/widgets/services/global-error.service';
import { MatchmediaService } from '@core/services/matchmedia.service';
import { map, takeUntil } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { SETTINGS } from '@environment/settings';
import { Md5 } from 'ts-md5/dist/md5';
import { CustomeHandlerService } from '@root/shared/services/custome-handler.service';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';
import * as pdlCutomHandlers from '@core/reb-pdl-custom-handlers';
import { RootComponent } from '../root.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';
import { CartSupportService } from '@support/cart-support/services/cart-support.service';
import { Cart } from '@support/api/proxies/responses/api-cart-response.interface';
import { PdpDataHandlerService } from '@root/shared/services/pdp-data-handler.service';
import {
  lineTypeEnum,
  TileIdAndLengthToCreateLine,
} from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { TileManagementService } from '@support/shared/services/tile-management.service';
import { PhoenixSupportService } from '@root/shared/services/phoenix-support-service';

/* Theme setup */
console.log('Location', location);
const now = new Date();
const time = now.getTime();
const days = 7;
const minutes = 60;
const seconds = 60;
const milliseconds = 1000;
const expireTime = time + days * minutes * seconds * milliseconds;
now.setTime(expireTime);
if (location.search.match(new RegExp(`brand=${SHARED_CONSTANTS.CONNECT_BRAND_NAME}`, 'i'))) {
  document.cookie = `brand= ${SHARED_CONSTANTS.CONNECT_BRAND_NAME}; expires= ${now.toUTCString()};path=/`;
} else if (location.search.match(new RegExp(`brand=${SHARED_CONSTANTS.PREPAID_BRAND_NAME}`, 'i'))) {
  document.cookie = `brand= ${SHARED_CONSTANTS.PREPAID_BRAND_NAME}; expires= ${now.toUTCString()};path=/`;
}
if (
  location.search.includes('code=') &&
  document.cookie.match(new RegExp(`brand=${SHARED_CONSTANTS.CONNECT_BRAND_NAME}`, 'i'))
) {
  const now = new Date();
  const time = now.getTime();
  const days = 1;
  const minutes = 60;
  const seconds = 60;
  const milliseconds = 1000;
  const expireTime = time - days * minutes * seconds * milliseconds;
  now.setTime(expireTime);
  document.cookie = 'brand=; expires=' + now.toUTCString() + ';path=';
}
/**
 * Web Entry Application component
 * This Module represents the root of the application
 * @access private
 */
@Wove({ moduleName: WEB_COMPONENT_CONSTANTS.WEB_MODULE })
@Component({
  selector: 'tmo-root',
  encapsulation: ViewEncapsulation.None, // allows for app.component.scss to insert global styles
  templateUrl: './web.component.html',
  styleUrls: ['../../../style-sheets/styles.scss'],
})
export class WebComponent extends RootComponent implements OnInit, OnDestroy {
  /**
   * Boolean method for loading Webcomponent
   */
  public loading: boolean;
  public interactionId: string;
  /**
   * Stores boolean value for SecondaryNavExpanded
   */
  public secondaryNavExpanded: boolean;
  /**
   * Error Modal to display when API failure occurs
   */
  @ViewChild('webGlobalError') public globalError: GlobalErrorModalComponent;
  /**
   *  Content to be populated in the error modal
   */
  public errorModalData: GlobalErrorModalInterface;
  /**
   * Content to be fetched for the global error modal
   */
  public aemContent: GlobalMessages;
  /**
   * Variable to hold global messages content
   */
  public footerAEMData: Footer;
  /**
   * Variable to hold Primary Header Navigation content
   */
  public headerAEMData: HeaderPrimaryNav;
  /**
   * Subject to unsubscribe
   */
  public ngUnsubscribe: Subject<void>;
  /**
   * Variable to reflect the marketing data interface
   */
  public marketingData: MarketingDataEmitterInterface;
  public isNewHeaderFooterEnabled: boolean;

  constructor(
    private httpEventInterceptorService: HttpEventInterceptorService,
    private navbarService: NavbarService,
    private customerProfileService: CustomerProfileService,
    private stateStoreUtilsService: StateStoreUtilsService,
    private commonUtils: CommonUtilService,
    private router: Router,
    private appConfig: AppConfig,
    private objectService: ObjectService,
    private contentProviderService: ContentProviderService,
    private workflowService: WorkflowService,
    private marketingService: MarketingService,
    private matchmediaService: MatchmediaService,
    private globalErrorService: GlobalErrorService,
    private apiGatewayService: ApiGatewayService,
    private customeHandlerService: CustomeHandlerService,
    public pdlWrapperService: PdlWrapperService,
    public pdlService: PdlService,
    private featureToggleUtilService: FeatureToggleUtilService,
    private cartSupportService: CartSupportService,
    private pdpDataHandlerService: PdpDataHandlerService,
    private tileManagementService: TileManagementService,
    private phoenixSupportService: PhoenixSupportService,
  ) {
    super(pdlWrapperService);
    this.ngUnsubscribe = new Subject<void>();
    this.loading = true;
    this.marketingData = { show: false };
    this.stateStoreUtilsService.setEsimToggleEnabled(this.appConfig.getConfig('isEsimEnabled'));
    this.stateStoreUtilsService.setDccPriceToggleEnabled(
      this.featureToggleUtilService.isDccPriceEnabled()
    );
    this.isNewHeaderFooterEnabled = this.featureToggleUtilService.isNewHeaderFooterEnabled();
    router.events.subscribe((e) => {
      const QMCookie = this.getCookie('QuantumMetricEnabled');
      if (
        QMCookie &&
        QMCookie.toLocaleLowerCase() !==
          this.stateStoreUtilsService.getQMCookie().toLocaleLowerCase()
      ) {
        this.stateStoreUtilsService.setQMCookie(QMCookie);
        location.reload();
      }
    });
  }

  /**
   * Loads the initial configuration for the Web Component
   * @returns void
   */
  public ngOnInit(): void {
    // checking for pheonxi handoff, will not affect the angular flow unless handoff is required
    if(this.featureToggleUtilService.isPhoenixByodEnabled()) {
      this.phoenixSupportService.checkAndHandleNavHandoff(window.location.href.split(window.location.origin)[1])
    }
    this.stateStoreUtilsService.setBrand(
      this.getCookie('brand') || SHARED_CONSTANTS.PREPAID_BRAND_NAME
    );
    this.loadPDLConfig();
    this.checklocalStorageForToken(); // For web channel check if anon token is present.
    this.loading = false;
    const win = window;
    const queryParam = win.location.search;
    const paramIndex: number = 5;
    /* Store Cart Count Cookie Name */
    this.stateStoreUtilsService.setCartCountCookieName(
      this.appConfig.getConfig(SHARED_CONSTANTS.CART_COUNT_COOKIE_NAME)
    );
    /* Store Cart Count Cookie Name */
    this.getAnonymousToken();
    const authCode = (
      window.location.search
        .substring(1)
        .split('&')
        .find((qp) => {
          return qp.split('=')[0] == 'code';
        }) || ''
    ).split('=')[1];
    if (authCode) {
      this.stateStoreUtilsService.setAuthCode(authCode);
    }

    this.navbarService
      .getContentData('footer')
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: FooterModuleEnhancements) => {
        // this.footerAEMData = this.isNewHeaderFooterEnabled ? data.digital_footer : data.footer;
        this.footerAEMData = data.footer;
      });

    this.navbarService
      .getContentData('header-primary-navigation')
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: ModuleEnhanceMentsNavbar) => {
        if (data && data.header_primary_nav) {
          this.stateStoreUtilsService.setNavBarData(data.header_primary_nav);
          this.headerAEMData = data.header_primary_nav;
        }
      });
    this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event): void => {
      if (event instanceof NavigationEnd) {
        this.stateStoreUtilsService.setCurrentUrl(event.url);
        this.workflowService.setWorkflowIdOnRouteChange(event.urlAfterRedirects);
        this.apiGatewayService.resetSpinnerData();
        const isDigitalCartTemplateEnabled = !!event.urlAfterRedirects.includes('/cart/review');
        this.stateStoreUtilsService.setCartReviewPage(isDigitalCartTemplateEnabled);
      }
    });

    this.workflowService
      .getContentData('workflow')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: Workflow[]) => {
        if (data) {
          this.stateStoreUtilsService.setWorkflowInformation(data);
        }
      });

    // To get the global messages content
    this.navbarService
      .getContentData('globalMessages')
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((data: GlobalMessages) => {
        this.aemContent = data;
        const radixParameter = 10;
        const maxLineData: MaxLinesData = {
          maxLines: parseInt(this.aemContent.globalMessages.maxLines, radixParameter),
          maxVoiceLines: parseInt(this.aemContent.globalMessages.maxVoiceLines, radixParameter),
          maxTabletLines: parseInt(this.aemContent.globalMessages.maxTabletLines, radixParameter),
        };
        this.stateStoreUtilsService.setMaxLineDetailsDefault(maxLineData);
      });

    this.errorModalData = {
      errorMessage: '',
      title: '',
      CTATitle: '',
      errors: [],
    };
    this.listenNavbarChanges();
    this.httpErrorCodesHandler();
    /*this.marketingService.watch().subscribe((data: {show: boolean, data: object}) => {
      this.marketingData = data;
      if (data.show) {
        this.pdlService.triggerCustomEvent('WebHomeComponent', 'pageLoad');
      }
    });*/
    const QMCookie = this.getCookie('QuantumMetricEnabled');
    this.stateStoreUtilsService.setQMCookie(QMCookie);
  }

  /**
   * Method to set token for anonymous user
   */
  public getAnonymousToken(): void {
    const token = this.stateStoreUtilsService.getToken();
    if (!this.commonUtils.isNotEmpty(token)) {
      this.customerProfileService
        .getAnonymousToken()
        .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
        .subscribe(
          (response: AnonymousTokenResponse) => {
            const timer = 300000;
            const ms = 1000;
            const accessToken = this.objectService.get(response, 'access_token');
            if (this.objectService.get(response, 'correlation')) {
              const correlation = this.objectService.get(response, 'correlation');
              this.stateStoreUtilsService.setCorrelation(correlation);
            } else {
              this.setDynamicInteractionID(accessToken);
            }
            // this.objectService.get(response, 'correlation');
            this.stateStoreUtilsService.setToken(accessToken);
            this.getPermission();
            this.interactionId = this.stateStoreUtilsService.getCorrelation();
            this.customerProfileService.interval = setInterval(
              () => {
                this.refreshToken();
              },
              <number>this.objectService.get(response, 'expires_in', '0') * ms - timer
            );
          },
          (error: APIError) => {}
        );
    } else if (
      !this.stateStoreUtilsService.getCorrelation() ||
      (this.stateStoreUtilsService.getCorrelation() &&
        this.stateStoreUtilsService.getCorrelation() === 'undefined')
    ) {
      /* Cart Retrieval after navigating from Phoenix */
      this.setDynamicInteractionID(token);
      /* Cart Retrieval after navigating from Phoenix */
      this.interactionId = this.stateStoreUtilsService.getCorrelation();
    }
  }
  /* Cart retrieval after navigating from Phoenix */
  public setDynamicInteractionID(token: string): void {
    const interactionCookieValue = this.cartSupportService.getCookie('interactionId');
    const cartIdCookieValue = this.cartSupportService.getCookie('cartId');
    const brandCookieValue = this.cartSupportService.getCookie('brand');
    const cartbrandCookieValue = this.cartSupportService.getCookie('cartBrand');
    let dynamicInteractioID = '';
    const isLogged = window.location.search.includes('code=');
    if (!interactionCookieValue) {
      dynamicInteractioID = this.generateInteractionId(token);
      this.stateStoreUtilsService.setCorrelation(dynamicInteractioID);
      this.cartSupportService.promotionsCartLoaded.next(false);
    } else if ((brandCookieValue && cartbrandCookieValue !== brandCookieValue) || isLogged) {
      dynamicInteractioID = this.generateInteractionId(token);
      this.stateStoreUtilsService.setCorrelation(dynamicInteractioID);
      const utcTime = this.cartSupportService.getUTCTime(1, false);
      this.cartSupportService.clearPhoenixCookie({ utcTime: utcTime });
      this.cartSupportService.promotionsCartLoaded.next(false);
    } else {
      dynamicInteractioID = interactionCookieValue;
      this.stateStoreUtilsService.setCorrelation(dynamicInteractioID);
      const cartId = cartIdCookieValue;
      const utcTime = this.cartSupportService.getUTCTime(1, false);
      this.setCartId({ cartId: cartId, removeCookie: true });
    }
  }

  public setCartId({
    cartId = '',
    removeCookie = false,
  }: {
    cartId: string;
    removeCookie: boolean;
  }): void {
    console.log(cartId, removeCookie);
    this.stateStoreUtilsService.setCartId(cartId);
    this.setCartData(cartId);
  }
  public setCartData(cartId: string): void {
    this.cartSupportService
      .applyPromoCode(SHARED_CONSTANTS.DUMMY_CART_PROMO, cartId)
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe(
        (cartResponse: Cart) => {
          if (cartResponse.lines && cartResponse.lines.length > 0) {
            const existingTileList = cartResponse.lines.map((cartLine: CartLine) => cartLine.id);
            this.stateStoreUtilsService.setTileIdList(existingTileList, lineTypeEnum.LINE);
            cartResponse.lines.forEach((cartLine: CartLine, index: number) => {
              const existingTile: TileIdAndLengthToCreateLine = {};
              existingTile.tileId = cartLine.id;
              existingTile.currentLength = index + 1;
              this.tileManagementService.createTile(
                lineTypeEnum.LINE,
                false,
                cartLine,
                undefined,
                existingTile
              );
            });
            this.tileManagementService.mapToCartResponse(cartResponse);
          }
          cartResponse.devices.forEach((item) => {
            this.pdpDataHandlerService.loadProductBackendCartInPDP(item);
          });
          this.cartSupportService.promotionsCartLoaded.next(true);
          // const subType = this.pdDataHandlerService.loadProductCartInPDP(cartResponse,false,true);
          //this.pdpDataHandlerService.setPdlSubtypeObjectForCart2(cartResponse, this.objectService.get(cartResponse, 'productSubType.0', ''), false);
          // this.cartSupportService.announceCartUpdate(cartResponse);
        },
        (error: APIError[]) => {
          this.cartSupportService.promotionsCartLoaded.next(false);
        }
      );
  }
  /* Cart Retrieval after navigating from Phoenix */
  /**
   * Handles http error code and show modals
   * @TODO does this need to be in the root??
   * @returns void
   */
  public httpErrorCodesHandler(): void {
    // All error status codes opens the error modals
    // use HttpErrorHandlerService to listen/subscribe error code update
    this.httpEventInterceptorService
      .listenHttpErrors()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((error: APIError) => {
        if (
          ERROR_MESSAGES.hasOwnProperty(error.endpoint) &&
          error.code !== GLOBAL_ERROR_EXCEPTION_CODE.CHANGE_PLAN_CONFLICT_ERROR
        ) {
          this.addErrorModalContent(error);
          this.globalError.setDisplayModal(true);
        }
      });
    // @TODO removed for TestFlight as this is redirecting for API failures aswell
    // this.httpEventInterceptorService.listenApiFailure().subscribe(() => {
    //   this.router.navigate([SHARED_CONSTANTS.ERROR_404_NAVIGATE]);
    // });
  }
  /**
   * Method to determine what message to be shown on error modal
   */
  public addErrorModalContent(error: APIError): void {
    this.errorModalData.title = this.aemContent.globalMessages.title;
    this.errorModalData.errorMessage = this.aemContent.globalMessages.assistedAuthenticatedMesssage;
    this.errorModalData.CTATitle = this.aemContent.globalMessages.unAuthenticatedButton;
    this.errorModalData.errors.push(error);
    this.errorModalData.interactionId = this.stateStoreUtilsService.getInteractionId();
    this.errorModalData.sessionId = this.stateStoreUtilsService.getSessionId();
  }
  /**
   * Destroys the configuration for the Web component page
   * @returns void
   */
  public ngOnDestroy(): void {
    this.navbarService.navbarChangeEmitter.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Method to redirect to home page when error occurs due to api failure
   */
  public navigateToHome(): void {
    this.errorModalData.errors = [];
    this.router.navigate([GLOBAL_ERROR_MODAL_CONSTANTS.DEFAULT_DESTINATION]);
  }

  /**
   * method to clear global error messages on child route change
   * @returns void
   */
  public onActivate(): void {
    this.globalErrorService.clearGlobalErrorMessage();
  }

  /**
   * Listens for expansion of the secondary nav form navbar service
   * @returns void
   */
  private listenNavbarChanges(): void {
    this.secondaryNavExpanded = this.navbarService.isSecondaryNavExpanded();
    this.navbarService.navbarChangeEmitter.subscribe((event: { id: string }) => {
      if (event && event.id === 'secondaryNavExpanded') {
        this.secondaryNavExpanded = this.navbarService.isSecondaryNavExpanded();
      }
    });
  }

  private refreshToken(): void {
    this.customerProfileService
      .getAnonymousToken()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe(
        (response: AnonymousTokenResponse) => {
          const accessToken = this.objectService.get(response, 'access_token');
          this.stateStoreUtilsService.setToken(accessToken);
        },
        (error: APIError) => {}
      );
  }

  private loadPDLConfig(): void {
    this.pdlWrapperService.setEventCaptureConfig(this.pdlWrapperService.pdlDefaultData, true);
    if (this.pdlWrapperService) {
      if (this.pdlWrapperService.setDataTrackConfig) {
        this.contentProviderService
          .getRequest('/content/t-mobile/en/configurations/pdl.content.json')
          .pipe(map((res: HttpResponse<Object>) => res.body))
          .subscribe((data: Content) => {
            if (
              data &&
              data.model &&
              data.model['model-data'] &&
              data.model['model-data']['pdl-enhancements']
            ) {
              this.pdlWrapperService.setDataTrackConfig(
                data.model['model-data']['pdl-enhancements']['data-track-config']
              );
              this.pdlWrapperService.setEventCaptureConfig(
                data.model['model-data']['pdl-enhancements']['event-config'],
                true
              );
            }
            this.setPdpConstants(data);
            const profileInfo = { responsiveState: '' };
            profileInfo.responsiveState = this.matchmediaService.isDesktop()
              ? 'Desktop'
              : this.matchmediaService.isPhone()
                ? 'Mobile'
                : 'Tablet';
            this.pdlWrapperService.trackData('web_home', 'profileData', profileInfo);
          });
      }
      if (this.pdlWrapperService.setCustomHandlers) {
        const pdlCustomHandlerss = {
          ...pdlCutomHandlers,
          myCustomHandler: this.customeHandlerService.myCustomHandler,
          myCustomEventHandler: this.customeHandlerService.myCustomEventHandler,
          myCustomGeoLocationHandler: this.customeHandlerService.myCustomGeoLocationHandler,
          myGenerateEventInfoTimestamp: this.customeHandlerService.myGenerateEventInfoTimestamp,
          myCustomEventHandlerForCart: this.customeHandlerService.myCustomEventHandlerForCart,
          myCustomClickEventHandler: this.customeHandlerService.myCustomClickEventHandler,
          myCustomModalEventHandler: this.customeHandlerService.myCustomModalEventHandler,
          myCustomRemoveEventHandler: this.customeHandlerService.myCustomRemoveEventHandler,
          errorOnPageLoad: this.customeHandlerService.errorOnPageLoad,
          selfServiceAction: this.customeHandlerService.selfServiceAction,
        };
        this.pdlWrapperService.setCustomHandlers(pdlCustomHandlerss);
      }
    }
  }

  /**
   * used to get permission for unauthenticated customer
   */
  private getPermission(): void {
    this.customerProfileService
      .getPermissions()
      .pipe(takeUntil(this.ngUnsubscribe.asObservable()))
      .subscribe((permissions: HttpResponse<Object>) => {
        this.stateStoreUtilsService.setPermission(permissions.body);
        this.customerProfileService.permissionsLoadedSource.next(true);
      });
  }
  /**
   * used to get token for unauthenticated customer
   */
  private checklocalStorageForToken(): void {
    // phx_ng_token is set in sessionStorage behind feature flag
    const phx_ng_token = sessionStorage.getItem('phx_ng_token');
    // check if phx_ng_token is present in sessionStorage
    // if present, set it as token and get interactionId from sessionStorage
    // this will persist the session between phoenix angular handoff
    // if not present, check for webanontoken and correlation in localStorage
    if(phx_ng_token) {
      this.stateStoreUtilsService.setToken(phx_ng_token);
      this.interactionId = sessionStorage.getItem('interactionId');
    }else{
      const accessToken = localStorage.getItem('webanontoken');
      const correlation = localStorage.getItem('correlation');
      if (accessToken) {
        localStorage.removeItem('webanontoken');
        this.stateStoreUtilsService.setToken(accessToken);
      }
      if (correlation) {
        localStorage.removeItem('correlation');
        this.stateStoreUtilsService.setCorrelation(correlation);
        this.interactionId = this.stateStoreUtilsService.getCorrelation();
      }
    }
    
  }

  private generateInteractionId(token: string): string {
    const limit: number = Number(SHARED_CONSTANTS.LIMIT);
    const limitForSessionId: number = Number(SHARED_CONSTANTS.LIMIT_SESSION_ID);
    const limitForDate: number = Number(SHARED_CONSTANTS.LIMIT_DATE);
    // tslint:disable-next-line:no-magic-numbers
    let dateForInteractionId = Math.floor(new Date().getTime() / 1000).toString();
    dateForInteractionId = dateForInteractionId = dateForInteractionId.split('').reverse().join('');
    const channel = SETTINGS.CHANNEL.toLocaleUpperCase();
    const sessionId = Md5.hashStr(token);
    const dynamicSessionSubString = 'ANON';
    const dynamicSessionID = ''.concat(
      dynamicSessionSubString,
      this.trimId(dateForInteractionId.toString(), limitForDate)
    );
    const interactionId = this.trimId(
      channel.concat('', sessionId.toString(), dynamicSessionID),
      limit
    );
    return interactionId;
  }

  private trimId(id: string, limit: number): string {
    return id.length > limit ? id.substring(0, limit) : id;
  }

  private setPdpConstants(data: Content): void {
    // if (data && data.model && data.model['model-data'] && data.model['model-data']['pdl-enhancements'] && data.model['model-data']['pdl-enhancements']['pdl-subtype-constants']) {
    //   this.stateStoreUtilsService.setPdlSubtypeConstants(data.model['model-data']['pdl-enhancements']['pdl-subtype-constants']);
    // }
    // if (data && data.model && data.model['model-data'] && data.model['model-data']['pdl-enhancements'] && data.model['model-data']['pdl-enhancements']['pdl-subcategory-override']) {
    //   this.stateStoreUtilsService.setPdlSubtypeOverrideConstants(data.model['model-data']['pdl-enhancements']['pdl-subcategory-override']);
    // }
    if (
      data &&
      data.model &&
      data.model['model-data'] &&
      data.model['model-data']['pdl-enhancements']
    ) {
      if (data.model['model-data']['pdl-enhancements']['pdl-subtype-constants']) {
        this.stateStoreUtilsService.setPdlSubtypeConstants(
          data.model['model-data']['pdl-enhancements']['pdl-subtype-constants']
        );
      }
      if (data.model['model-data']['pdl-enhancements']['pdl-subcategory-override']) {
        this.stateStoreUtilsService.setPdlSubtypeOverrideConstants(
          data.model['model-data']['pdl-enhancements']['pdl-subcategory-override']
        );
      }
      if (
        this.objectService.get(data, 'model.model-data.pdl-enhancements.pdp-subcategory-constants')
      ) {
        this.stateStoreUtilsService.setPageInfoSubCategoryConstantInPDP(
          this.objectService.get(
            data,
            'model.model-data.pdl-enhancements.pdp-subcategory-constants'
          )
        );
      }
      const cartPaymentConstants = this.objectService.get(
        data,
        'model.model-data.pdl-enhancements.cart-payment-constants'
      );
      if (cartPaymentConstants) {
        this.stateStoreUtilsService.setPdlCartPaymentConstants(cartPaymentConstants);
      }
      if (this.objectService.get(data, 'model.model-data.pdl-enhancements.pdp-type-constants')) {
        this.stateStoreUtilsService.setPdlTypeConstants(
          this.objectService.get(data, 'model.model-data.pdl-enhancements.pdp-type-constants')
        );
      }
    }
  }
  // tslint:disable-next-line:max-file-line-count
}
